<template>
<div class="backstage">
    <div class="backstagecenner">
    <h2>“云创展控”一站式云展管理平台</h2>
      <div class="desc">热点编辑、内容管理、营销监控、数据分析、轨迹跟踪、线索收集、VR带看</div>
         <!-- Swiper -->
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="slideback">
                              <img src="../../assets/imges/scheme/swiperadmin1.png"/>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="slideback">
                              <img src="../../assets/imges/scheme/swiperadmin2.png"/>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="slideback">
                              <img src="../../assets/imges/scheme/swiperadmin3.png"/>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="slideback">
                              <img src="../../assets/imges/scheme/swiperadmin4.png"/>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="slideback" id="q">
                              <img src="../../assets/imges/scheme/swiperadmin5.png"/>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="slideback" id="q">
                              <img src="../../assets/imges/scheme/swiperadmin6.png"/>
                    </div>
                </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
        </div>
    </div>
</div>

</template>
<script>
import Swiper from "swiper";
export default {
    mounted(){
        // 请求数据
        new Swiper('.swiper-container', {
            slidesPerView:5,
            // spaceBetween: 30,
            centeredSlides: true,
            loop:true,
            autoplay: {
                stopOnLastSlide:true
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
        })           
    },
}
</script>
<style scoped>
@import "../../../node_modules/swiper/dist/css/swiper.css";
.backstage{
   width: 100%;
   height: 700px;
      background: #fff;
}
.backstagecenner{
    height: 100%;
    width: 1202px;
    margin: 0px auto;
}
.backstagecenner h2{
    padding-top: 63px;
    text-align: center;
    color: #000000;
    font-weight: 400;
    font-size: 32px;
    font-weight: bold;
}
.desc{
    padding-top: 12px;
    padding-bottom: 60px;
    font-size: 18px;
    color: #000000;
    text-align: center
}
.swiper-container {
      width: 100%;
      height: 100%;
      padding-top: 0px;
}
.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: url("https://oss.3dyunchuang.com/home_pic/pic/bgcqg.png") no-repeat;
    background-size: 100% 100%;
    height: 500px;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);
}
#q{
        height: 389px!important;
}
.swiper-slide .slideback{
    width: 211px;
    height: 380px;
    position: absolute;
    left: 14px;
    border-radius: 8px;
    overflow: hidden;
    top: 36px;
}
.swiper-slide .slideback img{
    width: 100%;
    height: 100%;
}
.swiper-slide-active,.swiper-slide-duplicate-active{
    transform: scale(1);
}
</style>


// WEBPACK FOOTER //
// src/common/scheme/scheme-backstage.vue